module.exports = __webpack_public_path__ + "static/img/2.21e2a65.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/hk/upload/commonality/20251009/2.jpg
// module id = nkRG
// module chunks = 7